<template>
    <div class="list">
        <div 
            v-for="(video, index) in formatVideos" :key="index"
            class="item cursor-pointer"
            @click="selectedVideo = video"
        >
            <div class="cover overflow-hidden relative" :class="{withPicture: video.cover}">
                <div v-if="video.cover">
                    <img class="absolute inset-0 m-auto" :src="video.cover" alt="" />
                </div>
                <div v-else>
                    <Video :key="index"
                        :url="video.video_url"
                        :nocontrols="true"
                        :autoplay="false"
                        :automuted="true"
                        :quality="240"
                        type="realtime"
                        class="pointer-events-none"
                    >
                    </Video>
                </div>
                <i v-if="hideDetails" class="cover-icon-play fa-regular fa-circle-play"></i>
            </div>
            <div class="video-info" v-if="!hideDetails">
                <div class="date" v-if="video.date">
                    {{ video.date }}
                </div>
                <div class="title" v-if="video.title">
                    {{ video.title }}
                </div>
                <div class="cta-label" v-if="video.cta_label">
                    {{ video.cta_label }}
                </div>
            </div>

        </div>
        <div 
            class="modal z-40 top-0 left-0 fixed w-full h-full flex items-center justify-center" 
            v-if="selectedVideo"
        >
            <div class="modal-content relative w-full xl:w-7/12 md:w-10/12 mx-auto z-50 md:px-0 px-4">
                <div class="flex w-full justify-end">
                    <button class="close mb-4" @click="selectedVideo = null">
                        &#10006;
                    </button>
                </div>
                <div class="w-full mx-auto video-container">
                    <Video
                        class="mb-6"
                        :key="selectedVideo.video_url"
                        :url="selectedVideo.video_url"
                        :nocontrols="true"
                        :autoplay="false"
                        :automuted="false"
                        :fullscreenable="true"
                    >
                    </Video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Video from './Video.vue';
    export default {
        name: 'ListVideos',
        components: {
            Video,
        },
        data() {
            return {
                formatVideos: JSON.parse(this.videos),
                selectedVideo: null,
            }
        },
        props: {
            videos: {
                type: String,
                default: '',
            },
            hideDetails: {
                type: Boolean,
                default: false,
            },
        },
    }
</script>
<style lang="scss" scoped>
    .modal {
        background-color: rgba(#002132, .94);
    }
    .close {
        color: #FFF;
        font-size: 30px;
        opacity: 1;
        @screen lg {
            opacity: 0.2;
        }
        &:hover {
            opacity: 1;
        }
    }
    .cover {
        .icon {
            width: 58px;
        }
    }
</style>
